<template>
  <article v-if="page" class="wagb-legal">
    <div class="wagb-legal__intro">
      <p v-if="page.intro && typeof page.intro === 'string'">{{ page.intro }}</p>
      <p v-else-if="page.intro">
        <template v-if="page.intro.textBefore">{{ page.intro.textBefore }}</template
        ><router-link :to="page.intro.linkTo">{{ page.intro.linkText }}</router-link
        >{{ page.intro.textAfter }}
      </p>
      <p v-if="page.introAfter">{{ page.introAfter }}</p>
    </div>

    <section
      v-for="(section, idx) in page.sections"
      :key="idx"
      class="wagb-legal__section"
    >
      <h2>{{ section.title }}</h2>
      <template v-for="(block, bIdx) in section.paragraphs">
        <p v-if="typeof block === 'string'" :key="'p-' + bIdx">{{ block }}</p>
        <p v-else :key="'pl-' + bIdx">
          <template v-if="block.textBefore">{{ block.textBefore }}</template
          ><router-link :to="block.linkTo">{{ block.linkText }}</router-link
          >{{ block.textAfter }}
        </p>
      </template>
      <p v-if="section.listIntro">{{ section.listIntro }}</p>
      <ul v-if="section.list" class="wagb-legal__list">
        <li v-for="item in section.list" :key="item">{{ item }}</li>
      </ul>
      <p v-for="(para, pIdx) in section.paragraphsAfter" :key="'pa-' + pIdx">{{ para }}</p>
    </section>
  </article>
</template>

<script>
import '@/css/wagbappro-legal.scss';
import { getLegalPage } from '@/data/wagbappro/legal-id';

export default {
  name: 'LegalContent',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    page() {
      return getLegalPage(this.slug);
    },
  },
};
</script>
